import { IEffect } from './effect'

export const DamageTranslation: { [key: string]: string } = {
  slashing: 'Sieczne',
  blunt: 'Obuchowe',
  piercing: 'Kłute',
  fire: 'Ogień',
  cold: 'Chłód',
  electricity: 'Elektryczność',
  acid: 'Kwas',
  poison: 'Trucizna',
  magic: 'Magia',
  internal: 'Obrażenia wewnętrzne',
}

export const IEquipSlotTypes = [
  'head',
  'body',
  'hand',
  'gloves',
  'shoes',
  'belt',
  'ring',
  'necklace',
  'trinket',
]
type IEquipSlot = typeof IEquipSlotTypes[number]

export const EquipSlotTranslation: { [key in IEquipSlot]: string } = {
  head: 'Głowa',
  body: 'Tors',
  hand: 'Ręka',
  gloves: 'Rękawice',
  shoes: 'Buty',
  belt: 'Pas',
  ring: 'Pierścień',
  necklace: 'Naszyjnik',
  trinket: 'Kolczyk',
}

export const IWeaponProfTypes = [
  'arms',
  'small_blades',
  'swords',
  'big_swords',
  'blunts',
  'poles',
  'bows',
  'crossbows',
  'throwing',
]

type IWeaponProfType = typeof IWeaponProfTypes[number]

export const WeaponProfTranslation: { [key in IWeaponProfType]: string } = {
  arms: 'Walka wręcz',
  small_blades: 'Małe ostrza',
  swords: 'Miecze',
  big_swords: 'Duże miecze',
  blunts: 'Broń obuchowa',
  poles: 'Drzewce',
  bows: 'Łuki',
  crossbows: 'Kusze',
  throwing: 'Broń miotana',
}

export const IItemQualities = ['common', 'magic', 'strange', 'exceptional', 'uncommon']

type IItemQuality = typeof IItemQualities[number]

export const ItemQualityTranslation: { [key in IItemQuality]: string } = {
  common: 'Zwykły',
  magic: 'Magiczny',
  strange: 'Dziwny',
  exceptional: 'Wyjątkowy',
  uncommon: 'Nietypowy',
}

export interface IDamage {
  id: number
  slashing: string
  blunt: string
  piercing: string
  fire: string
  cold: string
  electricity: string
  acid: string
  poison: string
  magic: string
  internal: string
}

export interface IItem {
  id: number
  name: string
  name_unidentified: string
  description: string
  description_unidentified: string
  charges: number
  stackable: boolean
  consumable: boolean
  target_self: boolean
  equip_slot: IEquipSlot
  weight: number
  two_handed: boolean
  weapon_prof: IWeaponProfType
  delay: number
  range: number
  strength_mod: number
  quality: IItemQuality

  effect: IEffect
}

export interface IGiveItem {
  item_id: number
  game_id: number
  character_id: number
  identified: boolean
  quantity?: number
}

export interface IDumpItem {
  character_item_id: number
  character_id: number
  game_id: number
}

export interface IEquipItem {
  character_item_id: number
  character_id: number
  game_id: number
}

export interface IUseItem {
  character_item_id: number
  character_id: number
  game_id: number
}
